import types from 'actions/types'
import merge from 'lodash/merge'
import {combineReducers} from 'redux'
import {xor} from 'lodash'

export const targetLanguage = (state = 'en', action) => {
  switch (action.type) {
    case types.LANGUAGE_SET_TARGET:
      return action.language
    default:
      return state
  }
}

export const pendingTranslations = (state = [], action) => {
  switch (action.type) {
    case types.LANGUAGE_TRANSLATE_TEXT:
      return [
          ...state,
          action.text,
      ]
    case types.LANGUAGE_TEXT_TRANSLATED:
      return xor(state, Object.keys(action.languageMap))
    default:
      return state
  }
}

export const languageMap = (state = {}, action) => {
  switch (action.type) {
    case types.LANGUAGE_SET_TARGET:
      return {}
    case types.LANGUAGE_TEXT_TRANSLATED:
      return merge(state, action.languageMap)
    default:
      return state
  }
}

export default combineReducers({
  targetLanguage,
  pendingTranslations,
  languageMap,
})
